module.exports = __webpack_public_path__ + "static/img/2838_phase_function_Paper_Points.987f4e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2838_phase_function_Paper_Points.png
// module id = krHt
// module chunks = 0